'use client';

import { useState } from 'react';
import styles from './HomepageCarrierList.module.scss';
import Modal from 'components/Modal';
import UILink from 'components/ui/UILink';

const MODAL_TITLE_ID = 'carrier-list-modal-title';

const SepModal = () => {
  return (
    <>
      <h2 id={MODAL_TITLE_ID} className={styles.modalTitle}>
        You can typically enroll in Medicare coverage when you turn 65 or during
        the Annual Enrollment Period.
      </h2>
      <p className={styles.modalBody}>
        But there are situations where you may be eligible for a Special
        Enrollment Period. These can include losing health insurance through
        your employer, moving to a new area that your current plan doesn’t
        cover, and other reasons.
      </p>
      <p className={`${styles.modalBody} ${styles.phoneText}`}>
        Not sure if you qualify? Talk to a licensed insurance agent:{' '}
        <a href="tel:+18337485302">(833) 748-5302</a> TTY: 711
      </p>
    </>
  );
};

const formatCarrierList = (carriers: string[]): string => {
  if (carriers.length === 1) {
    return carriers[0];
  }

  if (carriers.length === 2) {
    return carriers.join(' and ');
  }

  const lastCarrier = carriers[carriers.length - 1];
  return `${carriers.slice(0, -1).join(', ')} and ${lastCarrier}`;
};

const HomepageCarrierList = ({ carriers }: { carriers: string[] }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section className="carriers">
      <div className="carrier-content">
        <p>
          Medicare Advantage, Medicare Supplement, and Part D prescription drug
          plans may be available from {formatCarrierList(carriers)} in your
          area.
        </p>
        <p>
          <strong>
            Are you eligible to enroll in Medicare coverage now?{' '}
            <UILink
              textType="body"
              size="large"
              label="Learn more"
              onClick={() => setIsOpen(true)}
              className={styles.learnMoreLink}
            />
          </strong>
        </p>
      </div>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        titleId={MODAL_TITLE_ID}
      >
        <SepModal />
      </Modal>
    </section>
  );
};

export default HomepageCarrierList;
